import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { propertyService } from "@/features/properties/model/propertyServices";
import { useAddress } from "@/shared/hooks/useAddress";
import { isValidUUID } from "@/features/properties/model/guestSession";
import styles from "./CommunityNewsFeedPage.module.css";
import { fetchNews } from "../services/news.service";

export const CommunityNewsFeedPage = () => {
  const { selectedAddress } = useAddress();
  const propertyId =
    selectedAddress && selectedAddress !== "__add__" && isValidUUID(selectedAddress)
      ? selectedAddress
      : null;

  const { data: propertyDetails, isFetched: propertyDetailsSettled } = useQuery({
    queryKey: [QUERY_KEYS.PROPERTY_DETAILS, propertyId],
    queryFn: () => propertyService.getPropertyById(propertyId!),
    enabled: Boolean(propertyId),
  });

  const { data, isLoading } = useQuery({
    queryKey: ["community-news-feed", propertyId ?? "default"],
    queryFn: () => fetchNews(propertyDetails ?? null),
    enabled: !propertyId || propertyDetailsSettled,
  });
  const articles = data?.data ?? [];
  console.log(articles, data, "articles344354");

  return (
    <div className={styles.page}>
      <div className={styles.headerRow}>
        <div>
          <h1 className={styles.title}>Community News Feed</h1>
          <p className={styles.subtitle}>Stay updated with local news, events, and insights.</p>
        </div>
      </div>

      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>Suggested News</h2>
      </div>

      <div className={styles.cardGrid}>
        {isLoading &&
          Array.from({ length: 4 }).map((_, index) => (
            <article
              className={`${styles.card} ${styles.loadingCard}`}
              key={`loading-card-${index}`}
            >
              <div className={styles.loadingImage} />
              <div className={styles.cardBody}>
                <div className={styles.loadingTitle} />
                <div className={styles.loadingLine} />
                <div className={`${styles.loadingLine} ${styles.loadingLineShort}`} />
              </div>
            </article>
          ))}
        {!isLoading &&
          articles.slice(0, 8).map((item) => (
            <a
              href={item.link || "#"}
              target="_blank"
              rel="noreferrer"
              className={styles.cardLink}
              key={item.id}
              onClick={(event) => {
                if (!item.link) {
                  event.preventDefault();
                }
              }}
            >
              <article className={styles.card}>
                <img
                  src={
                    item.thumbnail ||
                    "https://images.pexels.com/photos/1181675/pexels-photo-1181675.jpeg?auto=compress&cs=tinysrgb&w=1200"
                  }
                  alt={item.title}
                  className={styles.image}
                />
                <div className={styles.cardBody}>
                  <h3 className={styles.cardTitle}>{item.title}</h3>
                  <p className={styles.cardDescription}>{item.snippet}</p>
                </div>
              </article>
            </a>
          ))}
      </div>
    </div>
  );
};
